import { render, staticRenderFns } from "./OrganisationFilters.vue?vue&type=template&id=70c4a045&scoped=true&"
import script from "./OrganisationFilters.vue?vue&type=script&lang=js&"
export * from "./OrganisationFilters.vue?vue&type=script&lang=js&"
import style0 from "../../assets/css/filters.css?vue&type=style&index=0&id=70c4a045&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70c4a045",
  null
  
)

export default component.exports